<template>
  <div>
    <div class="navbar">
      <van-icon class="left-icon" name="arrow-left" @click="clickBack" />
      <span>{{ topicTag }}</span>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已经到底了"
      @load="onLoad"
      class="living-list"
    >
      <div
        class="video-item"
        v-for="video in dataList"
        :key="video.id"
        @click="handleClickItem(video)"
      >
        <div class="left-side">
          <div class="left-title">{{ video.articleTitle }}</div>
          <div class="left-info">
            <span class="time">{{ video.articleTime.split(" ")[0] }}</span>
            <span class="name">{{ video.publishName }}</span>
          </div>
        </div>
        <div class="right-side">
          <img :src="video.pictureUrl" alt="" style="object-fit: cover" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { queryTopicByTopicTag, clickRecord } from "@/http/api";

export default {
  name: "TopicTagDetail",
  data() {
    return {
      topicId: null,
      topicTag: "",
      dataList: [],
      pageNum: 1,
      totalPages: 0,
      loading: false,
      finished: false,
    };
  },
  mounted() {
    if(window.location.href.indexOf("share.gztv.com")){
      window.location.href=window.location.href.replace("share.gztv.com","app.gztv.com");
    }
    this.topicId = this.$route.query.topicId;
    this.topicTag = this.$route.query.topicTag;
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      queryTopicByTopicTag({
        topicId: this.topicId,
        topicTag: this.topicTag,
        pageNum: this.pageNum,
        pageSize: 10,
      }).then((res) => {
        console.log(res);
        this.totalPages = res.data.pages;
        this.dataList = [...this.dataList, ...res.data.records];
        this.loading = false;
        if (this.pageNum >= res.data.pages) {
          this.finished = true;
        }
      });
    },
    clickBack() {
      // this.$router.back();
      this.$router.push({
        name: "topicDetail",
        query: {
          id: this.topicId,
        },
      });
    },
    onLoad() {
      this.pageNum++;
      this.getData();
    },
    handleClickItem(item) {
      if (item.operateType == 1) {
        // articleDetail
        this.$router.push({
          name: "articleDetail",
          query: {
            id: item.operateId,
          },
        });
      } else if (item.operateType == 4) {
        this.$router.push({
          name: "topicDetail",
          query: {
            id: item.operateId,
          },
        });
      } else if (item.operateType == 5) {
        // liveDetail
        this.$router.push({
          name: "liveDetail",
          query: {
            id: item.operateId,
          },
        });
      } else {
        // videoDetail
        this.$router.push({
          name: "videoDetail",
          query: {
            id: item.operateId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.navbar {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100%;
  max-width: 580px;
  font-size: 16px;
  box-sizing: border-box;
  z-index: 999;
  background: #fff;
  border-bottom: 1px solid #eee;

  .left-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-40%);
    font-size: 16px;
  }
}

.living-list {
  margin-top: 50px;
}

.video-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 10px 15px;

  &:hover {
    background: #f9f9f9;
    border-radius: 8px;
  }

  .left-side {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    padding-right: 10px;
    height: 70px;

    .left-title {
      font-size: 16px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis; //文本溢出部分用省略号表示
      display: -webkit-box; //特别显示模式
      -webkit-line-clamp: 2; //行数
      line-clamp: 2;
      -webkit-box-orient: vertical; //盒子中内容竖直排列
    }

    .left-info {
      font-size: 10px;
      color: #999;

      .time {
        margin-right: 10px;
      }
    }
  }

  .right-side {
    & > img {
      width: 120px;
      height: 70px;
      border-radius: 4px;
    }
  }
}
</style>
